import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'
import Modal from 'styled-react-modal'

const StyledModal = Modal.styled({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: 'white',
  padding: '30px',
  width: '650px',
  margin: '30px',
})

const StyledPrimaryButton = styled(PrimaryButton)<{
  text?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}>`
  border: 1px solid black;
  background-color: ${({ theme }) => theme.colors.coolGray.cool250};
  color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  margin-top: 10px;
`

const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
`

interface StockModalProps {
  isOpen: boolean
  toggleModal: () => void
  stockMessage: string
}

const StockModal: React.FC<StockModalProps> = ({ isOpen, toggleModal, stockMessage }) => {
  return (
    <StyledModal isOpen={isOpen} onBackgroundClick={toggleModal} onEscapeKeydown={toggleModal}>
      <StyledParagraph>{stockMessage}</StyledParagraph>
      <StyledPrimaryButton text="close" onClick={toggleModal} />
    </StyledModal>
  )
}

export default StockModal
